module Meevo.Plugins.Register {
    export class PrintProxyModalController {
        static $inject = [
			"printProxyRequest", 
            "$mdDialog",
            "meevo.components.common.PrintProxyService"
        ];

        constructor(
			private printProxyRequest,
            private $mdDialog: ng.material.IDialogService,
            private printProxyService: Meevo.Components.Common.IPrintProxyService) {
        }

        openPrintProxy() {
	        this.printProxyService.initialize(this.printProxyRequest)
		        .then((response) => {
			        this.$mdDialog.hide(response);
		        })
		        .catch(() => {
			        this.$mdDialog.hide();
		        });
        }

        cancel() {
            this.$mdDialog.hide('cancel');
        }
    }   

    angular.module("meevo.plugins.register")
        .controller("meevo.plugins.register.PrintProxyModalController", PrintProxyModalController);
}